var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('BannerFacturacion'),_c('EasyProcess'),_c('CheckDB'),_c('Notification'),_c('CTAPlus'),_c('AllYouNeed')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }